<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '46',
	},
	height: {
		type: String,
		default: '32',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 58 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			fill="#1F72CD"
		/>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			stroke="#F2F4F7"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.1593 14.1667L4.85742 26.2446H11.2045L11.9913 24.3189H13.7899L14.5767 26.2446H21.5631V24.7748L22.1856 26.2446H25.7995L26.422 24.7438V26.2446H40.9517L42.7184 24.3689L44.3727 26.2446L51.8355 26.2601L46.5169 20.2394L51.8355 14.1667H44.4885L42.7686 16.0077L41.1664 14.1667H25.3601L24.0028 17.2841L22.6136 14.1667H16.2798V15.5864L15.5752 14.1667H10.1593ZM11.3874 15.8818H14.4812L17.998 24.0719V15.8818H21.3872L24.1034 21.754L26.6068 15.8818H29.979V24.5485H27.9271L27.9103 17.7573L24.9188 24.5485H23.0832L20.0749 17.7573V24.5485H15.8536L15.0533 22.6055H10.7297L9.9311 24.5468H7.66936L11.3874 15.8818ZM40.2 15.8818H31.8563V24.5433H40.0708L42.7184 21.6728L45.2703 24.5433H47.938L44.0606 20.2377L47.938 15.8818H45.3861L42.7519 18.7194L40.2 15.8818ZM12.8924 17.3481L11.468 20.8093H14.3153L12.8924 17.3481ZM33.9168 19.2583V17.6762V17.6747H39.1229L41.3946 20.2049L39.0223 22.7489H33.9168V21.0217H38.4686V19.2583H33.9168Z"
			fill="white"
		/>
	</svg>
</template>
